var React = require('react');

function IsiMinusBtnInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"y":"0.5","width":"25","height":"25","rx":"12.5","fill":"#D3ED12","key":0}),React.createElement("path",{"d":"M18.4998 13L6.49975 13","stroke":"#240041","strokeWidth":"2.25","strokeLinecap":"round","key":1})]);
}

IsiMinusBtnInline.defaultProps = {"width":"25","height":"26","viewBox":"0 0 25 26","fill":"none"};

module.exports = IsiMinusBtnInline;

IsiMinusBtnInline.default = IsiMinusBtnInline;
